module.exports = __webpack_public_path__ + "img/Straight-through-Process(3).f75a3db4.png";